import { RuntimeConfig } from "nuxt/schema";

export const autoDetectAffiliateUrlFormatter = (url: string, config: RuntimeConfig) => {
    if (/^https:\/\/www.amazon.com\//.test(url)) {
        return amazonFormatter(url, config);
    }

    return '#';
}

export const amazonFormatter = (url: string, config: RuntimeConfig) => {
    const clearUrl = url.split('?')[0];
    return `${clearUrl}?tag=${config.public.affiliateAmazonTag}`;
}